import axios from 'axios';
let backendUrl = process.env.REACT_APP_backendUrl

/**
 * Fetches organization picks for a particular event
 * @param event_id The id of the event
 * @param org_id The id of the organization
 * @return Array
 */
const getOrgPicks = async(event_id, org_id) => {
    try {
        const response = await axios.get(`${backendUrl}/orgpicks/${event_id}/${org_id}`)
        return response.data
    } catch (e) {
        console.log("An error: ", e)
    }
}

/**
 * Fetches an organization's spread picks for a particular event
 * @param event_id The id of the event
 * @param org_id The id of the organization
 * @return Array
 */
const getOrgSpreadPicks = async(event_id, org_id) => {
    try {
        const response = await axios.get(`${backendUrl}/orgspreadpicks/${event_id}/${org_id}`)
        return response.data
    } catch (e) {
        console.log("An error: ", e)

    }
}


/**
 * Fetches an organization's spread picks for a particular event
 * @param event_id The id of the event
 * @param org_id The id of the organization
 * @return Array
 */
const getOrgOUPicks = async(event_id, org_id) => {
    try {
        const response = await axios.get(`${backendUrl}/orgoverunderpicks/${event_id}/${org_id}`)
        return response.data
    } catch (e) {
        console.log("An error: ", e)
    }
}

/**
 * Fetches events under the current sport without a subevent
 * @param {String} The name of the sport 
 * @return {Array}
 */
const getFlatEventsWhereOrgAnalystParticipated = async(sport_name, org_id) => {
    try {
        const response = await axios.get(`${backendUrl}/events-without-subevents/${sport_name}/${org_id}`)
        return response.data
    } catch (e) {
        console.log("An error occured in fetching events with no subEvents: ", e)
    }
}

/**
 * Retrives the pick types (StraightUp/Spread/Over/Under That are avaialble on topics of this event and org)
 * @param eventId - The id of the event
 * @param orgId - The id of the org
 * @return Dict - A hash of the picktypes available
 */
const getOrgEventPickTypes = async (eventId, orgId) => {
    try {
        const response = await axios.get(`${backendUrl}/eventpicktypes/${eventId}/${orgId}`)
        return response.data
    } catch (e) {
        console.log("An error occured: ", e )
    }
}

//Gets a specific source
const getOrg = async id => {
    try {
      const response = await axios.get(`${backendUrl}/orgs/${id}`)
      return response.data
    } catch (e) {
      console.log("An error occured in getting the source")
      console.log(e)
    }
  }

export default {
    getOrgPicks,
    getFlatEventsWhereOrgAnalystParticipated,
    getOrg,
    getOrgSpreadPicks,
    getOrgOUPicks,
    getOrgEventPickTypes
}